import { createReducer, createSetter } from "@/redux/helpers/reducer";

import { DRAWER_MODE } from "./constants";
import * as actions from "./drawer.actions";

const initialState = {
  isOpen: false,
  mode: DRAWER_MODE.ENTRY,
  activeEntry: null,
  activeOrder: null,
  activeEvent: null,
  blockDraftIncomplete: false,
  pendingBlock: false,
  orderDetails: null,
  isFetchingOrderDetails: false,
};

export default createReducer(initialState, {
  [actions.setIsOpen]: createSetter("isOpen"),
  [actions.setMode]: createSetter("mode"),
  [actions.setActiveEntry]: createSetter("activeEntry"),
  [actions.setActiveOrder]: createSetter("activeOrder"),
  [actions.setActiveEvent]: createSetter("activeEvent"),
  [actions.setBlockDraftIncomplete]: createSetter("blockDraftIncomplete"),
  [actions.setPendingBlock]: createSetter("pendingBlock"),
  [actions.setOrderDetails]: createSetter("orderDetails"),
  [actions.setIsFetchingOrderDetails]: createSetter("isFetchingOrderDetails"),
  [actions.reset]: () => ({ ...initialState }),
});
